module.exports = __webpack_public_path__ + "img/client-1.ca1f2117.png";